





import { Component, Vue } from 'vue-property-decorator'
import { loadMicroApp } from 'qiankun'
import { micorApps } from '@/config'

@Component({
  name: 'dashBi',
})
export default class extends Vue {
  mountMicroApp: null | { unmount: Function } = null;
  micorApp = micorApps[0];
  created () {
    this.micorApp.props.routerBase = `/amc${this.$route.meta.routerBase}`
    console.log('rader created', this.micorApp.props.routerBase)
  }

  mounted () {
    console.log('rader mounted', this.micorApp.props.routerBase)
    if (this.$refs.dashbi) {
      try {
        console.log('micorApps', micorApps[0])
        this.mountMicroApp = loadMicroApp(this.micorApp)
      } catch (e) {
        console.log('e', e)
      }
    }

    console.log('mountMicroApp', this.mountMicroApp)
  }

  beforeDestroy () {
    if (this.mountMicroApp) {
      this.mountMicroApp.unmount()
    }
  }
}
